document.addEventListener('DOMContentLoaded', function() {
  let triangleBackgrounds = document.querySelectorAll('.triangle-background');
  let triangleBlueBackgrounds = document.querySelectorAll('.triangle-blue-background');
  let triangleBackgroundPurple = document.querySelectorAll('.triangle-purple-background');
  let triangleBlueTop = document.querySelectorAll('.triangle-blue-top');
  let backgroundGradient = document.querySelectorAll('.background-gradient');
  let ellipseBackgrounds = document.querySelectorAll('.ellipse-background');
  

  if(triangleBackgrounds.length > 0){
    triangleBackgrounds.forEach(function(triangleBackground) {
      var triangle = document.createElement('div');
      triangle.className = 'triangle';
      triangleBackground.appendChild(triangle);

      var observer = new IntersectionObserver(function(entries) {
        if(entries[0].isIntersecting === true)
          triangle.style.animationPlayState = 'running';
      }, { rootMargin: '-100px 0px', threshold: [0] });

      observer.observe(triangleBackground);
    });
  }

  if(triangleBlueBackgrounds.length > 0){
    triangleBlueBackgrounds.forEach(function(triangleBlueBackground) {
      var triangle = document.createElement('div');
      triangle.className = 'triangle';
      triangleBlueBackground.appendChild(triangle);

      var observer = new IntersectionObserver(function(entries) {
        if(entries[0].isIntersecting === true)
          triangle.style.animationPlayState = 'running';
      }, { rootMargin: '-100px 0px', threshold: [0] });

      observer.observe(triangleBlueBackground);
    });
  }

  if(ellipseBackgrounds.length > 0){
    ellipseBackgrounds.forEach(function(ellipseBackground) {
      var ellipse = document.createElement('div');
      ellipse.className = 'ellipse';
      ellipseBackground.appendChild(ellipse);

      var observer = new IntersectionObserver(function(entries) {
        if(entries[0].isIntersecting === true)
        ellipse.style.animationPlayState = 'running';
      }, { rootMargin: '-100px 0px', threshold: [0] });

      observer.observe(ellipseBackground);
    });
  }

  if(triangleBackgroundPurple.length > 0){
    triangleBackgroundPurple.forEach(function(triangleBackgroundPurple) {
      var triangle = document.createElement('div');
      triangle.className = 'triangle';
      triangleBackgroundPurple.appendChild(triangle);

      var observer = new IntersectionObserver(function(entries) {
        if(entries[0].isIntersecting === true)
          triangle.style.animationPlayState = 'running';
      }, { rootMargin: '-100px 0px', threshold: [0] });

      observer.observe(triangleBackgroundPurple);
    });
  }

  if(triangleBlueTop.length > 0){
    triangleBlueTop.forEach(function(triangleBlueTop) {
      var triangle = document.createElement('div');
      triangle.className = 'triangle';
      triangleBlueTop.appendChild(triangle);

      var observer = new IntersectionObserver(function(entries) {
        if(entries[0].isIntersecting === true)
          triangle.style.animationPlayState = 'running';
      }, { rootMargin: '-100px 0px', threshold: [0] });

      observer.observe(triangleBlueTop);
    });
  }
  

  if (backgroundGradient.length > 0) {
    backgroundGradient.forEach(function(background) {
        // 1. Initialisation des éléments
        var circleWhite = document.createElement('div');
        var rectangleWhiteBlueSide = document.createElement('div');
        var triangleBlue = document.createElement('div');

        circleWhite.className = 'circle-white';
        rectangleWhiteBlueSide.className = 'rectangle-blue-side';
        triangleBlue.className = 'triangle-blue';

        background.appendChild(circleWhite);
        background.appendChild(rectangleWhiteBlueSide);
        background.appendChild(triangleBlue);

        // 2. Mouvement parallaxe
        var parallaxCircleFactor = 0.1;
        var parallaxRectangleFactor = 0.4;
        var parallaxTriangleFactor = 0;

        window.addEventListener('scroll', function() {
            var scrollPosition = window.scrollY;
            var windowHeight = window.innerHeight;
            var backgroundMiddlePosition = background.offsetTop + (background.offsetHeight / 2);
            var windowMiddlePosition = scrollPosition + (windowHeight / 2);
            var differenceFromCenter = windowMiddlePosition - backgroundMiddlePosition;

            // Nous vérifions si la div est visible à l'écran pour appliquer le parallax
            if (scrollPosition + windowHeight > background.offsetTop && scrollPosition < background.offsetTop + background.offsetHeight) {
                circleWhite.style.transform = 'translateY(' + (-differenceFromCenter * parallaxCircleFactor) + 'px)';
                rectangleWhiteBlueSide.style.transform = 'translateY(' + (-differenceFromCenter * parallaxRectangleFactor) + 'px)';
                triangleBlue.style.transform = 'translateY(' + (-differenceFromCenter * parallaxTriangleFactor) + 'px)';
            }
        });
    });
}




});
